import styled from 'styled-components';
const FrameDataStyle = styled.div<any>`
  padding: ${(props) => props?.padding || '30px 0 0 0'};
`;

export { FrameDataStyle };
